/**
 * News Filter Functionality
 * Handles filtering of news entries based on article type
 */

function initNewsFilter() {
    const filterButtons = document.querySelectorAll('.news-filter-toggle-button');
    const newsItems = document.querySelectorAll('.news-item');

    if (!filterButtons.length || !newsItems.length) {
        return; // Exit if elements don't exist
    }

    // Add click event listeners to filter buttons
    filterButtons.forEach(button => {
        button.addEventListener('click', function () {
            const selectedCategory = this.getAttribute('data-category');

            // Update active button state
            filterButtons.forEach(btn => {
                btn.classList.remove('bg-darkest-blue', 'text-white');
                btn.classList.add('bg-light-grey', 'text-darkest-blue');
            });
            this.classList.remove('bg-light-grey', 'text-darkest-blue');
            this.classList.add('bg-darkest-blue', 'text-white');

            // Filter news items
            newsItems.forEach(item => {
                const articleType = item.getAttribute('data-article-type');

                if (selectedCategory === 'all' || articleType === selectedCategory) {
                    item.style.display = 'block';
                    item.style.opacity = '0';
                    // Trigger reflow to ensure transition works
                    item.offsetHeight;
                    item.style.opacity = '1';
                } else {
                    item.style.opacity = '0';
                    setTimeout(() => {
                        item.style.display = 'none';
                    }, 300); // Match transition duration
                }
            });
        });
    });

    // Set initial active state (first button)
    if (filterButtons.length > 0) {
        filterButtons[0].classList.remove('bg-light-grey', 'text-darkest-blue');
        filterButtons[0].classList.add('bg-darkest-blue', 'text-white');
    }
}

export default initNewsFilter;
